import { render, staticRenderFns } from "./popupTraining.vue?vue&type=template&id=8973a818&scoped=true&lang=html&"
import script from "./popupTraining.vue?vue&type=script&lang=js&"
export * from "./popupTraining.vue?vue&type=script&lang=js&"
import style0 from "./popupTraining.vue?vue&type=style&index=0&id=8973a818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8973a818",
  null
  
)

export default component.exports